"use client";

import React, { useRef } from "react";
import { Swiper } from "swiper/react";
import { Navigation, Parallax } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
interface CaseSliderProps {
  children?: React.ReactNode;
}

const CaseSlider: React.FC<CaseSliderProps> = ({ children }) => {
  const sliderRef = useRef<any>(null);

  return (
    <div
      ref={sliderRef}
      className="relative h-full overflow-hidden custom-slider"
    >
      <Swiper
        speed={600}
        navigation={true}
        modules={[Navigation, Parallax]}
        parallax={true}
      >
        {children}
      </Swiper>
    </div>
  );
};

export default CaseSlider;
